import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../UsuarioInspectorEnCampo/Asociados/PanelAsociadoComponent.module.css'
import { ObtenerClientes } from '../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { useDispatch, useSelector } from 'react-redux';
import TableBusquedaLotesComponent from './FisicoQuimico/TableBusquedaLotesComponent';

function PanelFisicoQuimicos(props) {

    return (
        <Fragment><br />
            <div className="container">
                <div className='row mt-3'>
                    <div className='col-xs-12 '>
                        <p className='mt-1' style={{ fontSize: '25px' }}>Búsqueda de Lotes</p>
                    </div>
                </div>
                <TableBusquedaLotesComponent></TableBusquedaLotesComponent>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelFisicoQuimicos)
